import React from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// Componentes
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';

// Páginas
import Home from './pages/Home';
import Blog from './pages/Blog';
import ChatAdmin from './pages/ChatAdmin';
import SiteAdmin from './pages/SiteAdmin';
import { SiteContentProvider } from './context/SiteContentContext';
import { UserProvider } from './context/UserContext';
const BUILD_VERSION = "2026-08-19-2";

function AppContent() {
  const location = useLocation();
  const isAdminRoute = ['/chat-admin', '/site-admin'].includes(location.pathname);

  return (
    <>
      <span hidden data-build-version="2026-08-19-2" />
      {!isAdminRoute && <Navbar />}

      <Routes>
        <Route path="/chat-admin" element={<ChatAdmin />} />
        <Route path="/site-admin" element={<SiteAdmin />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/" element={<Home />} />
      </Routes>

      {!isAdminRoute && <Footer />}
      {!isAdminRoute && <ChatWidget />}
    </>
  );
}

function App() {
  return (
    <UserProvider>
      <SiteContentProvider>
      <Router>
        <AppContent />
      </Router>
    </SiteContentProvider>
    </UserProvider>
  );
}

export default App;
